window.insert_to_table = (container, table, pos) => {
  if (!container) return;
  if (!table) return;

  pos = Math.max(pos - 1, 0);

  const tbody = table.querySelector('tbody');
  const columnCount = table.querySelectorAll('thead tr:first-child th').length ? table.querySelectorAll('thead tr:first-child th').length : table.querySelectorAll('tbody tr:not(:has(.image-text-card)) td').length;

  const newRow = document.createElement('tr');
  const newCell = document.createElement('td');
  newCell.appendChild(container);
  newCell.colSpan = columnCount;
  newRow.appendChild(newCell);

  const rows = tbody.querySelectorAll('tr');
  if (rows.length >= pos) {
    tbody.insertBefore(newRow, rows[pos]);
  } else {
    tbody.appendChild(newRow); // Если строк меньше — добавим в конец
  }
};
